/* src/views/jour/proto/JourChrome.jsx — LE CHROME PARTAGÉ de l'onglet
   Aujourd'hui, transcrit de docs/handoff/aujourdhui-complet.jsx (livré
   2026-08-26) : le bandeau « La journée de l'équipe » avec ses quatre
   compteurs, la bascule à sept sous-onglets, la nav de mois, les stats g3 et
   l'en-tête de groupe navy. LE DESSIN, PAS LA LOGIQUE — styles copiés tels
   quels, valeurs en props, gestes en onXxx. Les data-testid sont ajoutés
   (attributs), rien d'autre. */

import React from 'react'

/* ── le bandeau : « La journée de l'équipe » + 4 compteurs ────────── */
export function BandeauEquipe({ dateTexte, menages, controles, incidents,
  demandes, onAller }) {
  return (
    <div className="bandeau">
      <p className="bSous">{dateTexte}</p>
      <h2 className="bTitre">La journée de l'équipe</h2>
      <div style={{ display: 'flex', gap: '8px', marginTop: '12px', paddingTop: '11px',
        borderTop: '1px solid rgba(255,255,255,.18)', position: 'relative' }}>
        <button onClick={() => onAller('menages')} data-testid="equipe-menages"
          style={{ flex: '1', minWidth: '0', background: 'rgba(255,255,255,.13)',
            border: 'none', borderRadius: '11px', padding: '9px 10px', textAlign: 'left',
            cursor: 'pointer' }}>
          <span style={{ display: 'flex', alignItems: 'baseline', gap: '3px' }}>
            <b style={{ fontSize: '19px', color: '#fff', fontWeight: '600',
              lineHeight: '1' }}>{menages.faits}</b>
            <span style={{ fontSize: '11px',
              color: 'rgba(255,255,255,.5)' }}>/ {menages.total}</span>
          </span>
          <span style={{ display: 'block', fontSize: '9.5px', color: 'rgba(255,255,255,.72)',
            margin: '3px 0 5px' }}>Ménages</span>
          <span style={{ display: 'block', height: '3px', borderRadius: '2px',
            background: 'rgba(255,255,255,.2)', overflow: 'hidden' }}>
            <span style={{ display: 'block',
              width: `${menages.total ? Math.round((menages.faits / menages.total) * 100) : 0}%`,
              height: '100%', borderRadius: '2px', background: '#87b8e6' }} />
          </span>
        </button>
        <button onClick={() => onAller('controle')} data-testid="equipe-controles"
          style={{ flex: '1', minWidth: '0', background: 'rgba(255,255,255,.13)',
            border: 'none', borderRadius: '11px', padding: '9px 10px', textAlign: 'left',
            cursor: 'pointer' }}>
          {controles.total === 0 ? (
            // ⚠️ ZÉRO SUR ZÉRO NE SE DESSINE PAS EN JAUGE VIDE (correction
            // 27/08) : à 8h du matin, « 0/0 » ne dit rien — la phrase, si.
            <>
              <span style={{ display: 'block', fontSize: '9.5px',
                color: 'rgba(255,255,255,.72)' }}>Contrôles</span>
              <span style={{ display: 'block', fontSize: '9px', lineHeight: '1.35',
                color: 'rgba(255,255,255,.6)',
                marginTop: '3px' }}>aucun ménage terminé pour l'instant</span>
            </>
          ) : (
            <>
              <span style={{ display: 'flex', alignItems: 'baseline', gap: '3px' }}>
                <b style={{ fontSize: '19px', color: '#fff', fontWeight: '600',
                  lineHeight: '1' }}>{controles.faits}</b>
                <span style={{ fontSize: '11px',
                  color: 'rgba(255,255,255,.5)' }}>/ {controles.total}</span>
              </span>
              <span style={{ display: 'block', fontSize: '9.5px', color: 'rgba(255,255,255,.72)',
                margin: '3px 0 5px' }}>Contrôles</span>
              <span style={{ display: 'block', height: '3px', borderRadius: '2px',
                background: 'rgba(255,255,255,.2)', overflow: 'hidden' }}>
                <span style={{ display: 'block',
                  width: `${Math.round((controles.faits / controles.total) * 100)}%`,
                  height: '100%', borderRadius: '2px', background: '#87b8e6' }} />
              </span>
            </>
          )}
        </button>
        <button onClick={() => onAller('incidents')} data-testid="equipe-incidents"
          style={{ flex: '0 0 62px', background: 'rgba(245,201,184,.22)', border: 'none',
            borderRadius: '11px', padding: '9px 8px', textAlign: 'center',
            cursor: 'pointer' }}>
          <b style={{ display: 'block', fontSize: '19px', color: '#f5c9b8',
            fontWeight: '600', lineHeight: '1' }}>{incidents}</b>
          <span style={{ display: 'block', fontSize: '9px', color: 'rgba(255,255,255,.7)',
            marginTop: '4px' }}>Incidents</span>
        </button>
        <button onClick={() => onAller('horaires')} data-testid="equipe-demandes"
          style={{ flex: '0 0 62px', background: 'rgba(245,201,184,.22)', border: 'none',
            borderRadius: '11px', padding: '9px 8px', textAlign: 'center',
            cursor: 'pointer' }}>
          <b style={{ display: 'block', fontSize: '19px', color: '#f5c9b8',
            fontWeight: '600', lineHeight: '1' }}>{demandes}</b>
          <span style={{ display: 'block', fontSize: '9px', color: 'rgba(255,255,255,.7)',
            marginTop: '4px' }}>Demandes</span>
        </button>
      </div>
    </div>
  )
}

/* ── la bascule à sept sous-onglets ───────────────────────────────── */
const SOUS_ONGLETS = [
  { id: 'planning', ic: '▤', lb: 'Le planning' },
  { id: 'menages', ic: '◷', lb: 'Les ménages' },
  { id: 'controle', ic: '◉', lb: 'Contrôle' },
  { id: 'incidents', ic: '⚠', lb: 'Incidents' },
  { id: 'horaires', ic: '⇄', lb: 'Horaires' },
  { id: 'stock', ic: '◫', lb: 'Stock' },
  { id: 'taches', ic: '☰', lb: 'Mes tâches' },
]

export function BasculeJour({ actif, onSous }) {
  return (
    <div className="bascule">
      {SOUS_ONGLETS.map((o) => (
        <button key={o.id} className={actif === o.id ? 'on' : ''}
          data-testid={`jour-sous-${o.id}`}
          onClick={() => onSous(o.id)}>
          <span style={{ fontSize: '14px' }}>{o.ic}</span>{o.lb}
        </button>
      ))}
    </div>
  )
}

/* ── la nav de mois (36 px, pastille compte) ──────────────────────── */
export function NavMoisJour({ label, n, onPrec, onSuiv, suivActif, testId }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '7px',
      marginBottom: '12px' }} data-testid={testId}>
      <button onClick={onPrec} aria-label="Mois précédent"
        style={{ width: '36px', height: '36px', borderRadius: '9px',
          border: '1px solid #d5e3ee', background: '#fff', fontSize: '16px',
          color: '#3d5166' }}>‹</button>
      <span style={{ flex: '1', textAlign: 'center', display: 'inline-flex',
        alignItems: 'center', justifyContent: 'center', gap: '8px', minHeight: '36px',
        padding: '0 14px', borderRadius: '9px', background: '#3d5166', color: '#fff',
        fontSize: '12.5px', fontWeight: '600' }}>{label}
        <span style={{ fontSize: '10.5px', color: 'rgba(255,255,255,.6)',
          fontWeight: '400' }}>{n}</span>
      </span>
      {suivActif ? (
        <button onClick={onSuiv} aria-label="Mois suivant"
          style={{ width: '36px', height: '36px', borderRadius: '9px',
            border: '1px solid #d5e3ee', background: '#fff', fontSize: '16px',
            color: '#3d5166' }}>›</button>
      ) : (
        <button disabled aria-label="Mois suivant"
          style={{ opacity: '.3', cursor: 'default', width: '36px', height: '36px',
            borderRadius: '9px', border: '1px solid #d5e3ee', background: '#fff',
            fontSize: '16px', color: '#3d5166' }}>›</button>
      )}
    </div>
  )
}

/* ── les trois stats pleines (grid g3) ────────────────────────────── */
export function StatsTrio({ items }) {
  return (
    <div className={`grid ${items.length === 2 ? 'g2' : 'g3'}`} style={{ marginBottom: '12px' }}>
      {items.map((it, i) => (
        <div className="stat" key={i}
          style={it.fond === '#fff'
            ? { background: '#fff', borderColor: 'var(--bord)' }
            : { background: it.fond, borderColor: it.fond }}>
          <b style={{ color: it.fond === '#fff' ? 'var(--gris-d)' : '#fff' }}>{it.n}</b>
          <s style={{ color: it.fond === '#fff' ? 'var(--gris-d)'
            : 'rgba(255,255,255,.8)' }}>{it.lb}</s>
        </div>
      ))}
    </div>
  )
}

/* ── l'en-tête de groupe navy (date, logement, catégorie…) ────────── */
export function EnTeteGroupe({ titre, sous }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '9px', padding: '9px 12px',
      background: '#3d5166' }}>
      <span style={{ width: '7px', height: '7px', borderRadius: '50%',
        background: '#87b8e6', flexShrink: '0' }} />
      <span style={{ flex: '1', fontSize: '11.5px', fontWeight: '600',
        color: '#fff' }}>{titre}</span>
      <span style={{ fontSize: '10.5px', color: 'rgba(255,255,255,.6)' }}>{sous}</span>
    </div>
  )
}
